import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createTeam, deserializeTeam, fetchTeam, fetchTeams, joinTeam } from 'supporticon/api/teams'
import { isJustGiving } from '../../../../lib/environment'
import { fetchSessionTeam, selectTeam, selectPage } from '../../../../store/session'
import { selectButtonDefaults } from '../../../../store/site'
import get from 'lodash/get'
import withForm from 'constructicon/with-form'
import withStyles from 'constructicon/with-styles'
import styles from './styles'
import * as validators from 'constructicon/lib/validators'

import Button from '../../../ui/Button'
import ButtonGroup from 'constructicon/button-group'
import Form from 'constructicon/form'
import Grid from 'constructicon/grid'
import Heading from 'constructicon/heading'
import InputField from 'constructicon/input-field'
import Modal from '../../../ui/FlatModal'
import PaginationLink from 'constructicon/pagination-link'
import SearchResult from 'constructicon/search-result'
import SearchResults from 'constructicon/search-results'
import SingleSignOnLink from 'supporticon/components/single-sign-on-link'
import Success from '../../../ui/Success'
import RichText from '../../../ui/RichText'
import mapTemplate from '../../../../lib/mapTemplate'

class TeamRegistration extends Component {
  constructor (props) {
    super(props)
    this.closeModal = this.closeModal.bind(this)
    this.handleCreateTeam = this.handleCreateTeam.bind(this)
    this.renderModal = this.renderModal.bind(this)

    this.state = {
      errors: [],
      loading: false,
      modal: false,
      page: 1,
      successMessage: null,
      teams: [],
      view: 'initial'
    }
  }

  componentDidMount () {
    const { campaign, charity } = this.props

    this.setState({ loading: true })

    const params = {
      campaign,
      charity,
      limit: 1000
    }

    fetchTeams(params)
      .then(teams => teams.map(deserializeTeam))
      .then(teams => this.setState({ loading: false, teams }))
  }

  handleCreateTeam (event) {
    const {
      campaign,
      fetchSessionTeam,
      form,
      page,
      user
    } = this.props

    event.preventDefault()

    return form.submit().then(data => {
      this.setState({ loading: true, errors: [] })

      const params = {
        campaignId: campaign,
        captainSlug: page.slug,
        page: page.id,
        token: user.token,
        ...data
      }

      return Promise.resolve()
        .then(() => createTeam(params))
        .then(team => deserializeTeam(team))
        .then(team => {
          this.setState({ view: 'success', loading: false, successMessage: `Your team '${team.name}' has been created` })
          return fetchSessionTeam(team)
        }).catch(error => {
          const errors = get(error, 'data.error.errors', [{ message: 'An error occurred' }])
          this.setState({ loading: false, errors })
          return Promise.reject(error)
        })
    })
  }

  handleJoinTeam (team) {
    const {
      fetchSessionTeam,
      page,
      user
    } = this.props

    this.setState({ loading: true })

    const params = {
      id: team.owner || team.id,
      page: page.id,
      pageSlug: page.slug,
      teamSlug: team.slug,
      token: user.token
    }

    return joinTeam(params)
      .then(() => fetchTeam(team.id))
      .then(team => deserializeTeam(team))
      .then(team => {
        this.setState({ view: 'success', loading: false, successMessage: `You have joined the team '${team.name}'` })
        return fetchSessionTeam(team)
      }).catch(error => {
        const errors = get(error, 'data.error.errors', [{ message: 'An error occurred' }])
        this.setState({ loading: false, errors })
        return Promise.reject(error)
      })
  }

  closeModal () {
    this.setState({
      errors: [],
      loading: false,
      modal: false,
      page: 1,
      view: 'initial'
    })
  }

  renderModal () {
    const {
      button,
      classNames,
      form,
      pageSize,
      styles,
      team,
      user
    } = this.props

    const {
      errors,
      loading,
      modal,
      page,
      successMessage,
      teams,
      view
    } = this.state

    const modalProps = {
      isOpen: modal,
      onRequestClose: this.closeModal,
      spacing: 1.5,
      styles: styles.modal
    }

    switch (view) {
      case 'create':
        return (
          <Modal contentLabel='Create team' {...modalProps}>
            <Heading>Create a team</Heading>
            <Form
              isLoading={loading}
              noValidate
              submit='Create'
              errors={errors}
              onSubmit={this.handleCreateTeam}>
              <InputField {...form.fields.name} />
              {isJustGiving() && <InputField {...form.fields.target} styles={styles.target} />}
              {isJustGiving() && <InputField {...form.fields.story} styles={styles.story} />}
            </Form>
            <a className={classNames.link} onClick={this.closeModal}>Cancel</a>
          </Modal>
        )
      case 'join':
        // Pagination
        const isLastPage = (teams.length / pageSize) < page
        const currentIndex = (page - 1) * pageSize
        const pagedTeams = teams.slice(currentIndex, currentIndex + pageSize)

        return (
          <Modal contentLabel='Join a team' {...modalProps}>
            <Heading>Join a team</Heading>
            {errors.map(({ message }) => <div className={classNames.error}>{message}</div>)}
            <SearchResults
              emptyLabel='No teams found'
              loading={loading}
              styles={styles.results}>
              {pagedTeams.map((team) => (
                <SearchResult
                  key={team.id}
                  image={team.image}
                  title={team.name}
                  cta='Join Team'
                  button={{ onClick: () => this.handleJoinTeam(team) }}
                />
              ))}
            </SearchResults>
            {teams.length > pageSize && (
              <Grid justify={'center'} styles={styles.pagination}>
                <PaginationLink onClick={() => this.setState({ page: page - 1 })} direction='prev' disabled={page <= 1} />
                <PaginationLink onClick={() => this.setState({ page: page + 1 })} direction='next' disabled={isLastPage} />
              </Grid>
            )}
            <a className={classNames.link} onClick={this.closeModal}>Cancel</a>
          </Modal>
        )
      case 'success':
        return team && (
          <Modal contentLabel='Success!' {...modalProps}>
            <Success title={successMessage}>
              <SingleSignOnLink
                authType={user.authType}
                token={user.token}
                url={team.url}
                label='Visit your team page'
                {...button}
              />
            </Success>
            <a className={classNames.link} onClick={this.closeModal}>Close</a>
          </Modal>
        )
      default:
        return null
    }
  }

  render () {
    const {
      button,
      classNames,
      team,
      user,
      page,
      styles,
      successTeamCopy = [],
      successCreateTeamButtonLabel,
      successJoinTeamButtonLabel
    } = this.props

    return (
      <div className={classNames.root}>
        {team ? (
          <SingleSignOnLink
            authType={user.authType}
            token={user.token}
            url={team.url}
            label={`Visit your team (${team.name})`}
            {...button}
          />
        ) : (
          <div>
            <RichText styles={styles.copy}>
              {successTeamCopy.map((item) => ({
                ...item,
                text: item.text ? mapTemplate(item.text, { user, page }) : 'Fundraising with others? Find a team or create your own'
              }))}
            </RichText>
            <ButtonGroup styles={styles.buttons}>
              <Button tag='a' onClick={() => this.setState({ modal: true, view: 'create' })}>{mapTemplate(successCreateTeamButtonLabel || 'Create team', { user, page })}</Button>
              <Button tag='a' onClick={() => this.setState({ modal: true, view: 'join' })}>{mapTemplate(successJoinTeamButtonLabel || 'Join team', { user, page })}</Button>
            </ButtonGroup>
          </div>
        )}
        {this.renderModal()}
      </div>
    )
  }
}

TeamRegistration.defaultProps = {
  pageSize: 5
}

const mapState = (store) => ({
  button: selectButtonDefaults(store),
  team: selectTeam(store),
  page: selectPage(store)
})

const mapDispatch = { fetchSessionTeam }

const form = () => ({
  fields: {
    name: {
      label: 'Team name',
      placeholder: 'Enter your team name'
    },
    ...isJustGiving() && {
      target: {
        label: 'Fundraising target',
        placeholder: '1,000',
        validators: [
          validators.required('Enter your team fundraising target')
        ]
      },
      story: {
        type: 'textarea',
        label: 'Team story',
        validators: [
          validators.required('Please enter your team story')
        ]
      }
    }
  }
})

export default compose(
  connect(mapState, mapDispatch),
  withForm(form),
  withStyles(styles)
)(TeamRegistration)
